<template>
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <div class="table-wrapper">
            <el-table :data="rows" v-loading="loading" style="width: 100%">
                <el-table-column label="ID" prop="id" width="200" />
                <el-table-column label="用户ID" prop="userId" width="200">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewUser(scope.row.userId)">{{
                            scope.row.userId
                        }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="收件人" prop="name" width="150">
                    <template #default="{ row }">
                        <el-text class="mx-1">{{
                            `${row.address.name}`
                            }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="联系电话" prop="tel" width="160">
                    <template #default="{ row }">
                        <el-text class="mx-1">{{
                            `${row.address.tel}`
                            }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="地址" prop="address" width="300">
                    <template #default="{ row }">
                        <el-text class="mx-1">{{
                            `${row.address.country}-${row.address.province}-${row.address.city}-${row.address.address}`
                            }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="卡片" prop="cards" width="250">
                    <template #default="scope">
                        <div class="draw-images">
                            <div v-for="([id, count], index) in Object.entries(scope.row.cards)" :key="id"
                                class="draw-image-item">
                                <el-badge :value="count" type="primary" :offset="[-15, 10]">
                                    <img :src="cardStore.cardsObj[id]?.image" loading="lazy" />
                                </el-badge>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="物流公司" prop="deliveryCompany" width="200" />
                <el-table-column label="物流单号" prop="deliveryNumber" width="200" />
                <el-table-column label="状态" prop="status" width="120">
                    <template #default="scope">
                        <el-text v-if="scope.row.status === 0" class="mx-1" type="danger">待处理</el-text>
                        <el-text v-else-if="scope.row.status === 1" class="mx-1" type="warning">处理中</el-text>
                        <el-text v-else-if="scope.row.status === 2" class="mx-1" type="primary">已发货</el-text>
                        <el-text v-else-if="scope.row.status === 3" class="mx-1" type="success">完成</el-text>
                        <el-text v-else-if="scope.row.status === -1" class="mx-1" type="info">用户取消</el-text>
                        <el-text v-else-if="scope.row.status === -2" class="mx-1" type="info">管理员取消</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="管理员备注" prop="adminRemark" width="200" />
                <el-table-column label="时间" prop="createdAt" width="200">
                    <template #default="scope">
                        {{ $formatTime(scope.row.createdAt) }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" min-width="200">
                    <template #default="scope">
                        <el-link v-if="scope.row.status === 0" underline="always" type="warning"
                            @click="setShipInProgress(scope.row)">开始处理</el-link>
                        <el-link v-if="scope.row.status === 1" underline="always" type="primary"
                            @click="showDeliver(scope.row)">发货</el-link>
                        <el-link v-if="scope.row.status === 2" underline="always" type="success"
                            @click="completeDeliverCards(scope.row)">完成</el-link>
                        <el-divider v-if="[0, 1, 2].includes(scope.row.status)" direction="vertical" />
                        <el-link underline="always" type="primary" @click="showSetRemark(scope.row)">备注</el-link>
                        <el-divider v-if="scope.row.status === 0" direction="vertical" />
                        <el-link v-if="scope.row.status === 0" underline="always" type="info"
                            @click="cancelShip(scope.row)">取消</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
            <el-pagination v-model:current-page="filters.page" v-model:page-size="filters.size"
                :page-sizes="[10, 20, 50]" :total="filters.total" layout="total, sizes, prev, pager, next, jumper"
                @current-change="loadData" @size-change="loadData" />
        </div>

        <el-dialog v-model="setParams.showSetRemarkDialog" title="备注" width="600px">
            <el-form :model="setParams" label-width="100px">
                <el-form-item label="备注" prop="adminRemark">
                    <el-input v-model="setParams.adminRemark" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="setParams.showSetRemarkDialog = false">取消</el-button>
                <el-button v-loading="setParams.loading" type="primary" @click="setRemarkToShip">确定</el-button>
            </template>
        </el-dialog>
        <el-dialog v-model="setParams.showSetDeliverDialog" title="发货" width="600px">
            <el-form :model="setParams" label-width="100px">
                <el-form-item label="物流公司" prop="deliveryCompany">
                    <el-input v-model="setParams.deliveryCompany" />
                </el-form-item>
                <el-form-item label="物流单号" prop="deliveryNumber">
                    <el-input v-model="setParams.deliveryNumber" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="setParams.showSetDeliverDialog = false">取消</el-button>
                <el-button v-loading="setParams.loading" type="primary" @click="deliverCards">确定</el-button>
            </template>
        </el-dialog>
    </el-card>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { apiCall } from "@/utils/api";
import { useCardStore } from "@/stores/card/card";

const cardStore = useCardStore();

const route = useRoute();
const router = useRouter();

const loading = ref(false);

const rows = ref([]);

const filters = reactive({
    page: Number(route.query.page) || 1,
    size: Number(route.query.size) || 20,
    total: 0,
});

const setParams = reactive({
    showSetRemarkDialog: false,
    showSetDeliverDialog: false,
    loading: false,
    adminRemark: "",
    deliveryCompany: "",
    deliveryNumber: "",
    row: null,
});

watch(
    filters,
    (val) => {
        router.replace({ query: { ...val } });
    },
    { deep: true }
);

async function cancelShip(row) {
    loading.value = true;

    const response = await apiCall("user.cancelUserShip", {
        id: row.id,
    });

    loading.value = false;
    if (!response) {
        return false;
    }
    ElMessage.success('取消成功');
    row.status = -2;
}

async function setShipInProgress(row) {
    loading.value = true;

    const response = await apiCall("user.setShipInProgress", {
        id: row.id,
    });

    loading.value = false;
    if (!response) {
        return false;
    }
    ElMessage.success('设置成功');
    row.status = 1;
}

async function completeDeliverCards(row) {
    loading.value = true;

    const response = await apiCall("user.completeDeliverCards", {
        id: row.id,
    });

    loading.value = false;
    if (!response) {
        return false;
    }
    ElMessage.success('完成订单');
    row.status = 3;
}

function showSetRemark(row) {
    setParams.adminRemark = "";
    setParams.row = row;
    setParams.showSetRemarkDialog = true;
}

async function setRemarkToShip() {
    setParams.loading = true;

    const response = await apiCall("user.setRemarkToShip", {
        id: setParams.row.id,
        adminRemark: setParams.adminRemark,
    });

    setParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success('备注成功');
    setParams.row.adminRemark = setParams.adminRemark;
    setParams.showSetRemarkDialog = false;
}

function showDeliver(row) {
    setParams.deliveryNumber = "";
    setParams.row = row;
    setParams.showSetDeliverDialog = true;
}

async function deliverCards() {
    setParams.loading = true;

    const response = await apiCall("user.deliverCards", {
        id: setParams.row.id,
        deliveryCompany: setParams.deliveryCompany,
        deliveryNumber: setParams.deliveryNumber,
    });

    setParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success('发货成功');
    setParams.row.status = 2;
    setParams.row.deliveryCompany = setParams.deliveryCompany;
    setParams.row.deliveryNumber = setParams.deliveryNumber;
    setParams.showSetDeliverDialog = false;
}

async function loadData() {
    loading.value = true;

    const params = {
        page: filters.page || 1,
        size: filters.size || 20,
    };

    const response = await apiCall("user.getUserShipLogs", params);
    if (!response) {
        return false;
    }
    filters.total = response.count;
    rows.value = response.rows;

    loading.value = false;
}

function viewUser(id) {
    router.push(`/user/${id}`);
}

onMounted(async () => {
    await cardStore.getAll();
    await loadData();
});
</script>

<style scoped>
.draw-images {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
    gap: 2px;
    padding: 2px;
}

.draw-image-item {
    position: relative;
    width: 60px;
    aspect-ratio: 3 / 4;
    overflow: hidden;
    border-radius: 8px;
    background: #f6f6f6;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.draw-image-item:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.draw-image-item img {
    width: 60px;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    cursor: pointer;
    transition: 0.3s ease;
}
</style>
